@switch (breakSvc.breakPointDevice()) {
@default {
  <div class="auth-mobile-page-container ps-h-100">
    <div class="ps-w-100 ps-d-flex ps-flex-wrap">
      <div class="authentication-title-container">
        <p purpleEditableText tranKey='request_reset_password_page_title' class="auth-form-title">
          {{ T.REQUEST_RESET_PASSWORD.page_title | translation: [] }}
        </p>
        <p purpleEditableText tranKey='request_reset_password_page_subtitle' class="auth-form-subtitle">
          {{ T.REQUEST_RESET_PASSWORD.page_subtitle | translation: [] }}
        </p>
      </div>

      @if(purpleFormFieldGroups!= undefined) {
        <purple-form [disabledForm]="isLoading" class="ps-w-100"
        [(formGroup)]="validateForm" [purpleFormFieldGroups]="purpleFormFieldGroups">
      </purple-form>
      }
    </div>

    <div class="ps-w-100 ps-d-flex ps-flex-wrap ps-mt-auto">
      <div purpleEditableText tranKey='request_reset_password_page_login_disclaim' class="login-disclaim" [innerHTML]="T.request_reset_password_page_login_disclaim | translation: 
        [((tsvc.currentLanguage())??'')+'/login']"></div>

      <purple-simple-button [isLoading]="isLoading" [isDisabled]="isLoading" purpleEditableText
        [buttonText]="T.REQUEST_RESET_PASSWORD.page_reset | translation: []" cssClass="ps-mt-auto reset-button"
        (click)="requestResetPassword()" buttonType="primary">
      </purple-simple-button>
    </div>
  </div>
}

@case ('desktop') {
  <div class="desktop-page-external-container">
    <div class="desktop-page-container">
      <div class="ps-w-100 ps-d-flex ps-flex-wrap auth-container">
        <div class="auth-container-form-container">
          <div class="auth-form-container auth-login-form-container">
            <p purpleEditableText tranKey='request_reset_password_page_desktop_form_title' class="auth-form-title">
              {{ T.REQUEST_RESET_PASSWORD.page_desktop_form_title | translation: [] }}
            </p>
            <p purpleEditableText tranKey='request_reset_password_page_desktop_form_subtitle'
              class="auth-form-subtitle">
              {{ T.request_reset_password_page_desktop_form_subtitle | translation}}
            </p>
            @if (purpleFormFieldGroups!= undefined) {
              <purple-form [disabledForm]="isLoading" class="ps-w-100"
                [(formGroup)]="validateForm" [purpleFormFieldGroups]="purpleFormFieldGroups">
              </purple-form>

            }

            <purple-simple-button  [isLoading]="isLoading" [isDisabled]="isLoading" purpleEditableText
              [buttonText]="T.REQUEST_RESET_PASSWORD.page_reset | translation: []" cssClass="ps-mt-auto"
              (click)="requestResetPassword()" buttonType="primary">
            </purple-simple-button>

            <div purpleEditableText tranKey='request_reset_password_page_login_disclaim' class="login-disclaim"
              [innerHTML]="T.request_reset_password_page_login_disclaim | translation: 
              [((tsvc.currentLanguage())??'')+'/login']"></div>
          </div>
        </div>
        <div contentId="authentication-img" contentTypeId="auth-page" purpleEditableImage class="auth-container-img">
        <!-- <div class="auth-container-img"> -->
          <div class="black-overlay">
          </div>
          <div class="text-overlay">
            <div class="ps-w-100 ps-d-flex ps-flex-wrap ps-justify-content-center">
              <!-- <p purpleEditableText tranKey='auth_page_purple-fit_name' class="purple-fit-text">{{ T.AUTH_PAGE.purple_fit_name | translation: [] }}</p> -->
              <div class="purple-fit-text-logo" contentId="purple-fit-logo" contentTypeId="auth-page" purpleEditableImage></div>
              <p purpleEditableText tranKey='auth_page_promo_disclaimer' class="purple-fit-promo-text">
                {{ T.AUTH_PAGE.promo_disclaimer | translation: [] }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

}